import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import { useEditIncentivesMarketTermsAndConditionsTemplateModal } from '../context/EditIncentivesMarketTermsAndConditionsTemplateModalContext';

const EditIncentivesMarketTermsAndConditionsTemplateModalHeader: FC = () => {
  const { t } = useTranslate();
  const { actions } = useEditIncentivesMarketTermsAndConditionsTemplateModal();

  return (
    <div className="modal-header">
      <h5 className="modal-title">
        {t('EditIncentivesMarketTermsAndConditionsTemplateTitle')}
      </h5>
      <button
        type="button"
        className="close"
        aria-label={t('Close')}
        onClick={actions.handleCloseModal}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
};

export default EditIncentivesMarketTermsAndConditionsTemplateModalHeader;
